// extracted by mini-css-extract-plugin
export default {"BuildingDescriptionBlock":"BuildingDescriptionBlock_BuildingDescriptionBlock__fTzuo","text":"BuildingDescriptionBlock_text__Z+sVg"};